import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: false,
});

// Attach Bearer token from localStorage if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("qb_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP" }).format(
    Number(n || 0)
  );

// Files need the Bearer token, so fetch as a blob and show it in a new tab.
export async function openFile(fileId, quoteId) {
  const win = window.open("", "_blank");
  try {
    const res = await api.get(`/files/${fileId}`, { params: quoteId ? { quote: quoteId } : {}, responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    if (win) win.location.href = url;
    else window.location.assign(url);
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (win) win.close();
    let msg = "Could not open file";
    try { msg = JSON.parse(await e.response.data.text()).detail || msg; } catch { /* non-JSON */ }
    const { toast } = await import("sonner");
    toast.error(msg);
  }
}
